module.exports = __webpack_public_path__ + "static/media/pexels-photo-140945.7dfd970f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/002_be/pexels-photo-140945.jpeg
// module id = 766
// module chunks = 0